module.exports = __webpack_public_path__ + "img/9788937482762.3f855d47.jpg";